import { Component, Input, OnChanges, OnDestroy, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { animate, sequence, state, style, transition, trigger } from '@angular/animations';

import { Observable, Subject, Subscription, TeardownLogic, filter, map, take, takeUntil } from 'rxjs';

import { UserInfo } from 'services/user/user.service.class';

import { NavMenuService, NavMenuItem, NavMenuItemStatus } from './navmenu.service';

@Component({
    selector: 'app-nav-menu',
    styleUrls: ['navmenu.component.scss'],
    templateUrl: 'navmenu.component.html',
    animations: [
        trigger('iconspinner', [
            state(
                'false',
                style({
                    transform: 'rotate(0deg)',
                })
            ),
            state(
                'true',
                style({
                    transform: 'rotate(90deg)',
                })
            ),
            transition('false <=> true', animate('100ms')),
        ]),
        trigger('submenuexpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class NavMenuComponent implements OnChanges, OnDestroy {
    @ViewChild('navmenu') navmenu!: ElementRef;

    private _subrelease = new Subscription();
    set subrelease(sub: TeardownLogic) {
        this._subrelease.add(sub);
    }

    @Input() logout!: () => Observable<boolean>;
    @Input() about!: () => Observable<boolean>;
    FilteredItems: NavMenuItem[] = [];
    @Input() HideChevrons = false;
    NavMenuItemStatus = NavMenuItemStatus;
    @Input() user: UserInfo | null = null;
    ViewReady = false;

    @Output() navigate: EventEmitter<string> = new EventEmitter<string>();

    constructor(private navMenuSvc: NavMenuService, private router: Router) {
        // Monitor for updates of nav items from the associated service.
        this.subrelease = this.navMenuSvc.MenuItems.subscribe((menus) => {
            this.FilteredItems = menus || [];
            this.ViewReady = true;
        });
    }

    ngOnDestroy() {
        this._subrelease.unsubscribe();
    }

    ngOnChanges() {
        const self = this;
        // const curRole = self.user?.CurrentRole;

        // Process the menu items against the user (if available) to determine which are available.
        // const fitems: NavMenuItem[] = [];

        // (self.items || []).forEach((itm) => {
        //     // const toUse =
        //     //     itm.Exclude !== true &&
        //     //     (itm.Rights?.includes(SystemRole.All) || itm.Rights?.some((r) => self.userSvc.GetUserRightsAccess(r)));

        //     // // If we're not using this menu at all, no need to scan for submenu availability.
        //     // if (!toUse) {
        //     //     return;
        //     // }

        //     const uitem = { ...itm };

        //     // If there are submenus, we need to process them as well, via filtering.
        //     if (uitem.Submenus?.length) {
        //         uitem.Submenus = uitem.Submenus.filter((sm) => {
        //             return true;
        //             // return (
        //             //     sm.Exclude !== true &&
        //             //     (sm.Rights?.includes(SystemRole.All) || sm.Rights?.some((r) => self.userSvc.GetUserRightsAccess(r)))
        //             // );
        //         });
        //     }

        //     fitems.push(uitem);
        // });

        // // Has the available menu options changed? Compile the unique menu IDs for every menu existing right now.
        // const curIDs = (self.FilteredItems || [])
        //     .map((f) => [f.MenuID, ...(f.Submenus || []).map((s) => s.MenuID)])
        //     .reduce((p, c) => p.concat(...c), [])
        //     .sort((a, b) => a - b)
        //     .join(',');
        // const newIDs = (fitems || [])
        //     .map((f) => [f.MenuID, ...(f.Submenus || []).map((s) => s.MenuID)])
        //     .reduce((p, c) => p.concat(...c), [])
        //     .sort((a, b) => a - b)
        //     .join(',');

        // if (curIDs === newIDs) {
        //     // Menus have stayed the same. Do not replace.
        //     return;
        // }

        // // Now, we need to quickly sync up the expansion for any menu item in the current menu list (if any) to the new one
        // // being built.
        // self.FilteredItems?.forEach((f) => {
        //     if (f.IsExpanded) {
        //         const otherparent = fitems.find((o) => o.MenuID === f.MenuID);
        //         if (otherparent) {
        //             otherparent.IsExpanded = true;
        //         }
        //     }
        // });

        // self.FilteredItems = fitems;

        // if (self.FilteredItems && self.FilteredItems.length) {
        //     for (let i = 0, j = self.FilteredItems.length; i < j; ++i) {
        //         self.FilteredItems[i].ButtonIndex = i;
        //     }
        // }

        // // Initial update the url we are currently at.
        // self.UpdateMenuItems(self.router.routerState.snapshot.url);
    }

    // #region Clear All Active Buttons Method

    ClearAllActiveButtons() {
        // Clear all active flags
        // if (this.FilteredItems && this.FilteredItems.length > 0) {
        //     this.FilteredItems.forEach((item) => {
        //         item.Active = false;
        //     });
        // }
    }

    // #endregion

    HandleItemClick(item: NavMenuItem) {
        const self = this;

        if (item == null) {
            return;
        }

        if (item.IsLogout === true || item.IsAbout === true) {
            // Get a handle to the currently active nav item.
            //     const curActive = self.FilteredItems.find((aitem) => aitem.Active);

            //     // Clear all actives
            //     this.ClearAllActiveButtons();

            //     // Set the About button as active visually.
            //     item.Active = true;

            // Call the appropriate method, and wait for the dialog to dismiss.
            const methodFn = item.IsLogout ? self.logout : self.about;

            methodFn()
                .pipe(take(1))
                .subscribe(() => {
                    // Clear the about button as active.
                    // item.Active = false;
                    // // Restore focus to the previously active item.
                    // if (curActive) {
                    //     curActive.Active = true;
                    //     const btn = self.navmenu.nativeElement.querySelector('#NavBtn_' + curActive.ButtonIndex);
                    //     if (btn) {
                    //         btn.focus();
                    //     }
                    // }
                });
            return;
        }

        // Is this a parent element for a set of submenus? If so, this click action only expands/collapses.
        if (item.Submenus && !!item.Submenus.length) {
            item.IsExpanded = !item.IsExpanded;

            return;
        }

        // If this item has an external URL, it's just a link to a file, so open that link in a new tab.
        if (item.ExternalURL) {
            window.open(item.ExternalURL, '_blank', 'noopener,noreferrer');
            return;
        }

        // Attempt to navigate to the route, if one is defined.
        if (item.Route) {
            const actRoute = item.Route;

            self.router.navigate([actRoute]);
        }
    }

    UpdateMenuItems(url: string) {
        // Clear all active flags
        // if (this.FilteredItems && this.FilteredItems.length > 0) {
        //     this.FilteredItems.forEach((item) => {
        //         item.Active = false;
        //         if (item.Submenus && !!item.Submenus.length) {
        //             item.Submenus.forEach((sitem) => (sitem.Active = false));
        //         }
        //     });
        // }
        // // Strip off any trailing pieces of the url path
        // const urlroot = url.match(/^(\/.*?)(\/.*)?$/);
        // if (urlroot && urlroot.length >= 2) {
        //     url = urlroot[1];
        // }
        // // Strip off a leading slash (if any).
        // if (url[0] === '/') {
        //     url = url.substr(1);
        // }
        // // Check the url against all of our menu items to look for a match.
        // if (!!url && this.FilteredItems && this.FilteredItems.length > 0) {
        //     // const parsedUrl = url.replace(/^\/(.*?)\/(.*)$/, '~/$2');
        //     this.FilteredItems.forEach((item) => {
        //         const itemRoute = item.Route || '';
        //         if (itemRoute.indexOf(url) >= 0) {
        //             // Found a match on this item. Set the button to being active.
        //             item.Active = true;
        //         } else {
        //             // No match found on this item. Does this item have submenus? If so, check them.
        //             if (item.Submenus && !!item.Submenus.length) {
        //                 item.Submenus.forEach((subitem) => {
        //                     const subitemRoute = subitem.Route || '';
        //                     if (subitemRoute.indexOf(url) >= 0) {
        //                         // Found a match on a subitem. Set the button to being active.
        //                         subitem.Active = true;
        //                         // Also set the parent expansion button to being expanded (if it isn't, say for reloading)
        //                         item.IsExpanded = true;
        //                         item.Active = true;
        //                     }
        //                 });
        //             }
        //         }
        //     });
        // }
    }
}
